import $ from 'jquery';
export var match = function (value, element) {
    var target = $(element).data('match_to_container');
    if ($(target).not('.validate-equalTo-blur').length) {
        $(target).addClass('validate-equalTo-blur');
    }
    var errorContainer = '#' + $(element).data('errorMatch');
    var targetContainer = '#' + $(target).data('errorMatch');
    if (value === $(target).val() || $(target).val() === '') {
        if ($(errorContainer).hasClass('is-invalid')) {
            $(errorContainer).removeClass('is-invalid');
        }
        if ($(targetContainer).hasClass('is-invalid')) {
            $(targetContainer).removeClass('is-invalid');
        }
        $(target).removeClass('is-invalid-matched');
        return true;
    }
    else {
        $(errorContainer).addClass('is-invalid');
        $(target).addClass('is-invalid is-invalid-matched');
        return false;
    }
};
